import {FC, useState} from 'react'
import {bookingCalendar} from "../../constants/global";
import {storeBooking} from "../../lib/booking";
import WorkshopMessage from "./WorkshopMessage";

interface Props {
    workshops:any[],
    booking:Booking,
    setBooking:Function,
    getMonth:Function,
    loading:boolean
}

const WorkshopSelect: FC<Props> = ({workshops, booking, setBooking, getMonth, loading}) => {
    const [selectedOption, setSelectedOption] = useState(booking.workshop);
    workshops.sort((a, b) => a.menu_order > b.menu_order ? 1 : -1)

    const handleClick = (workshop:any) => {
        if(loading){
            return;
        }

        setSelectedOption(workshop.id)
        booking.workshop = parseInt(workshop.id)
        booking.resource = parseInt(workshop.id)
        booking.group = null
        bookingCalendar.slots = []
        booking.date = ''

        booking.hjulskifte.date = booking.window.date = ''
        booking.hjulskifte.spot_id = booking.window.spot_id = null

        if(booking.booking_flow === 'window' && booking.window.form.window_damage_type === 'chip') {
            booking.submission.slug = ''
            booking.submission.name = ''
            booking.group = workshop.group
        }

        if(booking.booking_flow === 'hjulskifte') {
            booking.submission.slug = ''
            booking.submission.name = ''
        }

        storeBooking(booking, setBooking)
        getMonth()
    }

    if(!workshops)
       return <></>

    if(booking.calendar_carousel.steps[booking.calendar_carousel.index].slug !== 'date')
        return <></>

    return (
        <>
            <WorkshopMessage booking={booking} workshops={workshops}/>

            <div className="workshop-select">
                {workshops.map((workshop:any, i:number) => (
                    <div className={`workshop-select-item ${loading ? "disabled" : ""} ${selectedOption === workshop.id ? "active" : ""}`} key={i} onClick={e => handleClick(workshop)}>
                        {workshop.name}<br/>
                        <span className={'address'}>{workshop.address}</span>
                    </div>
                ))}
            </div>
        </>
    )
};

export default WorkshopSelect
